import { GalaxyConfig, StarData, StarPosition } from 'types/galaxy';

export const calculateHelixPositions = (
  starsData: StarData[],
  _config: GalaxyConfig
): StarPosition[] => {
  const helixRadius = 30;
  const helixSpread = 10;
  const maxHeight = 60;
  const turns = 12;

  // Sort by PnL descending
  const sorted = starsData.map((_, i) => i).sort((a, b) => starsData[b].pnl - starsData[a].pnl);
  const count = sorted.length;
  const positions: StarPosition[] = new Array(count);

  sorted.forEach((idx, rank) => {
    const t = rank / count;
    const angle = t * turns * Math.PI * 2;
    const r = helixRadius + t * 15 + (Math.random() - 0.5) * helixSpread;
    const y = maxHeight / 2 - t * maxHeight + (Math.random() - 0.5) * 2;

    positions[idx] = {
      x: Math.cos(angle) * r,
      y,
      z: Math.sin(angle) * r,
    };
  });

  return positions;
};
